import { LandingItem } from "@/interfaces/landingItem";
import { Component, Prop, Vue } from "vue-property-decorator";
import Template from "./landing.template.vue";

@Component({
  mixins: [Template]
})
export default class LandingComponent extends Vue {
  @Prop({ default: () => [] }) private items!: LandingItem[];
}
